import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { useQueryParam, useEnumQueryParam } from 'hooks/useQueryParam';
import { useUpdateQueryParams } from 'hooks/useUpdateQueryParams';

import { Tabs } from 'components/UI/Tabs';

import { fetchArtworksByQuery, fetchArtistsByQuery } from 'features/search/actions';
import { SEARCHABLE_TYPES } from 'features/search/types';
import { useArtworksSearchResults } from 'features/search/hooks/useArtworksSearchResults';
import { useArtistsSearchResults } from 'features/search/hooks/useArtistsSearchResults';

import { SearchBar } from 'components/search/SearchBar';
import { Artworks } from './Artworks';
import { Users } from './Users';

import { TABS_INDEX_MAP, formatResultsSuffix } from './index';

export const SearchResults: React.FC = () => {
  const dispatch = useDispatch();
  const query = useQueryParam('query', '');
  const type = useEnumQueryParam('type', SEARCHABLE_TYPES, 'artworks');
  const [activeTab, setActiveTab] = useState(type === 'artists' ? 1 : 0);
  const { updateQueryParams } = useUpdateQueryParams();

  const validatedQuery = query.length >= 2 ? query : '';

  useEffect(() => {
    if (validatedQuery.length) {
      dispatch(fetchArtworksByQuery(validatedQuery));
      dispatch(fetchArtistsByQuery(validatedQuery));
    }
  }, [validatedQuery]);

  useEffect(() => {
    updateQueryParams({ type: TABS_INDEX_MAP[activeTab] });
  }, [activeTab]);

  const artworksResults = useArtworksSearchResults(query);
  const artistsResults = useArtistsSearchResults(query);

  return (
    <>
      <SearchBar
        onSubmit={(newSearchQuery) => updateQueryParams({ query: newSearchQuery })}
        showLoading={
          validatedQuery.length > 0 &&
          (artworksResults.initial ||
            artworksResults.isFetching ||
            artworksResults.initial ||
            artworksResults.isFetching)
        }
      />
      {validatedQuery.length ? (
        <>
          <div className='entity-tab-nav--dark-background'>
            <div className='container'>
              <Tabs
                items={[
                  formatResultsSuffix(artworksResults, 'Artworks'),
                  formatResultsSuffix(artistsResults, 'Artists'),
                ]}
                index={activeTab}
                onChange={(index) => {
                  setActiveTab(index);
                }}
              />
            </div>
          </div>
          <div>
            {TABS_INDEX_MAP[activeTab] === 'artworks' ? (
              <Artworks
                artworks={artworksResults.objects || []}
                isFetching={artworksResults.initial || artworksResults.isFetching}
                zeroResultsMessage={'No artworks matching %s were found.'.replace(
                  '%s',
                  `“${query}”`,
                )}
                query={validatedQuery}
              />
            ) : null}
            {TABS_INDEX_MAP[activeTab] === 'artists' ? (
              <Users
                users={artistsResults.objects || []}
                isFetching={artistsResults.initial || artistsResults.isFetching}
                zeroResultsMessage={'No artists matching %s were found.'.replace(
                  '%s',
                  `“${query}”`,
                )}
                query={validatedQuery}
              />
            ) : null}
          </div>
        </>
      ) : null}
    </>
  );
};
